import PropTypes from 'prop-types';
import React, { Component } from 'react';
import BottleSelector from '../BottleSelector';
import BusinessPlanSubSectionTitle from '../BusinessPlanSubSectionTitle';
import InputNumberUnit from '../InputNumberUnit';
import LabelDescription from '../LabelDescription';
import SalesTestLayout from '../SalesTestLayout';
import StarsSpinner from '../StarsSpinner';
import './styles.css';

class SalesTest extends Component {
	render() {
		const {
			Body,
			BodyLeft,
			BodyRight,
			BodyLeftRow,
			BodyLeftRowLabel,
			BodyRightLabel,
			Footer,
			FooterValue
		} = SalesTestLayout;

		const { game } = this.props;

		const { viewMode } = game;

		const {
			supposedPrice,
			supposedDaysReceivable,
			supposedMarketingExpenses,
			supplierBottleChoice,
			supposedQuality,
			supposedSoldUnits,
			supposedDemandQuota
		} = game.sales;

		return (
			<div className="sales-test">
				<SalesTestLayout>
					<BusinessPlanSubSectionTitle label={'sales-test-title'} label2={'sales-only-test-area'} />
					<Body>
						<BodyLeft>
							<BodyLeftRow>
								<BodyLeftRowLabel label="selling-price" />
								<InputNumberUnit
									active={!viewMode}
									unit="€/U"
									variable={supposedPrice}
									step={0.1}
								/>
							</BodyLeftRow>
							<BodyLeftRow>
								<BodyLeftRowLabel label="marketing-expenses" />
								<InputNumberUnit
									active={!viewMode}
									unit="€"
									variable={supposedMarketingExpenses}
									step={100000}
								/>
							</BodyLeftRow>
							<BodyLeftRow>
								<BodyLeftRowLabel
									label="days-in-receivables"
									description="days-in-receivables-desc"
								/>
								<InputNumberUnit
									active={!viewMode}
									unit="DAYS"
									variable={supposedDaysReceivable}
								/>
							</BodyLeftRow>
							<BodyLeftRow>
								<BodyLeftRowLabel label="quality" description="quality-desc" />
								<StarsSpinner variable={supposedQuality} active={!viewMode} />
							</BodyLeftRow>
						</BodyLeft>
						<BodyRight>
							<BodyRightLabel label="select-bottle-model" />
							<BottleSelector
								variable={supplierBottleChoice}
								active={!viewMode}
							/>
						</BodyRight>
					</Body>
					<Footer>
						<LabelDescription
							label="perpective-unit-sales"
							description="perpective-unit-sales-desc"
						/>
						<FooterValue variable={supposedSoldUnits} unit="u" />
						<LabelDescription label="market-share" />
						<FooterValue variable={supposedDemandQuota} unit="%" multiplier={100} />
					</Footer>
				</SalesTestLayout>
			</div>
		);
	}
}

SalesTest.propTypes = {
	game: PropTypes.shape({
		id: PropTypes.string.isRequired,
		viewMode: PropTypes.bool,
		sales: PropTypes.shape({
			supposedPrice: PropTypes.object,
			supposedDaysReceivable: PropTypes.object,
			supposedMarketingExpenses: PropTypes.object,
			supplierBottleChoice: PropTypes.object,
			supposedQuality: PropTypes.object,
			supposedSoldUnits: PropTypes.object,
			supposedDemandQuota: PropTypes.object
		})
	})
};

export default SalesTest;
